import { green } from "@/pages/(app)/home/components/colors";
import useTranslation from "@babackapp/translations/use-translation";
import { ListIcon } from "lucide-react";
import { useReturnRequestsFilters } from "../../../providers/use-return-requests-filters";
import QuickFilterItem from "./quick-filter-item";
import useCountFilteredReturnRequests from "@babackapp/private-api-client/client/use-count-filtered-return-requests";
import { useEffect } from "react";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

export default function AllQuickFilter() {
  const t = useTranslation();
  const { search, filters, clearAll, quickFilter, setQuickFilter } =
    useReturnRequestsFilters();
  const { data: shop } = useCurrentShopSuspense();

  const active =
    quickFilter === null && [...filters.entries()].length === 0 && !search;

  const onClick = () => {
    clearAll();
    setQuickFilter(null);
  };

  const { data: results, refetch } = useCountFilteredReturnRequests({
    shopId: shop.id,
    filters,
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <QuickFilterItem
      active={active}
      count={results?.totalCount}
      title={t("returnRequestsQuickFilters.all.title")}
      description={t("returnRequestsQuickFilters.all.description")}
      icon={<ListIcon className="size-3" color={green} />}
      onClick={onClick}
    />
  );
}
